import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import Icon, { IconSizes, IconTypes, IconVariants } from '../../components/foundations/Icon';
import Button from '../../components/atoms/Button';
import { TRANSLATION_KEY } from '../constants';
import css from './WatchlistEmptyPanel.css';

const NO_MONITORS_KEY = `${TRANSLATION_KEY}.NO_MONITORS`;

const WatchlistEmptyPanel = ({ onRestore, restoring = false, canRestore = false }) => (
    <div className={css.panel}>
        <div className={css.iconBadge}>
            <Icon
                name="binoculars"
                type={IconTypes.TABLER}
                size={IconSizes.LARGE}
                variant={IconVariants.ACTIVE}
                interactive={false}
            />
        </div>
        <div className={css.heading}>
            <Translate id={`${NO_MONITORS_KEY}.HEADING`} />
        </div>
        <div className={css.body}>
            <Translate id={`${NO_MONITORS_KEY}.BODY`} />
        </div>
        {canRestore && (
            <Button type="link" className={css.restoreLink} disabled={restoring} onClick={onRestore}>
                <Translate id={`${NO_MONITORS_KEY}.RESTORE_LINK`} />
            </Button>
        )}
    </div>
);

WatchlistEmptyPanel.propTypes = {
    onRestore: PropTypes.func.isRequired,
    restoring: PropTypes.bool,
    canRestore: PropTypes.bool,
};

export default WatchlistEmptyPanel;
